"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProxyAdmin__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "contract AdminUpgradeabilityProxy",
                name: "proxy",
                type: "address",
            },
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "changeProxyAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract AdminUpgradeabilityProxy",
                name: "proxy",
                type: "address",
            },
        ],
        name: "getProxyAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract AdminUpgradeabilityProxy",
                name: "proxy",
                type: "address",
            },
        ],
        name: "getProxyImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract AdminUpgradeabilityProxy",
                name: "proxy",
                type: "address",
            },
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract AdminUpgradeabilityProxy",
                name: "proxy",
                type: "address",
            },
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class ProxyAdmin__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "ProxyAdmin";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ProxyAdmin__factory = ProxyAdmin__factory;
ProxyAdmin__factory.bytecode = _bytecode;
ProxyAdmin__factory.abi = _abi;
